exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-ancestor[data-v-3dc7545d]{padding:20px;text-align:center}.action[data-v-3dc7545d]{margin-right:5px}", ""]);

// exports
